$('#close_cros_drawer').on('click', function () {
    $('body').removeClass('overflow-hidden-tablet');
});

$('.menu_close_text').on('click', function () {
    $('body').removeClass('overflow-hidden-tablet');
});

jQuery(document).ready(function(){
var OSName="Unknown OS"; 
        if (navigator.appVersion.indexOf("Win")!=-1) OSName="Windows"; 
        if (navigator.appVersion.indexOf("Mac")!=-1) OSName="MacOS"; 
        if (navigator.appVersion.indexOf("X11")!=-1) OSName="UNIX"; 
        if (navigator.appVersion.indexOf("Linux")!=-1) OSName="Linux"; 
    
        document.body.classList.add( OSName);
});

$(document).ready(function() {
    $('.template_index .right_review_col .slick-arrow').on('click', function() {
        if ($('.slick-prev').hasClass('slick-disabled')) {
            $('.outer_right_review_col').removeClass('new-class');
        } else {
            $('.outer_right_review_col').addClass('new-class');
        }
    });
});



// $(document).ready(function() {
//   $('.view_priduct_top').click(function(event) {
//     event.preventDefault(); 
//     $('html, body').animate({ scrollTop: 0 }, 'smooth');
//   });
// });